module.exports = __webpack_public_path__ + "static/sport/h505.924f10f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/h505.png
// module id = X6E/
// module chunks = 0